module.exports = __webpack_public_path__ + "img/eye-closed.e2312ce2.svg";